import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { withRouter } from 'react-router-dom';
import useOnEsc from 'hooks/useOnEsc';
import useTrapFocus from 'hooks/useTrapFocus';
import useRandomId from 'hooks/useRandomId';
import useFocusOnOpen from 'hooks/useFocusOnOpen';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import getOrCreateElementById from 'commons/getOrCreateElementById';
import MobileModal from 'components/consumer/MobileModal';
import BodyScrollLock from 'components/consumer/BodyScrollLock';
import IconSimpleArrowLeft from 'components/icons/iconSimpleArrowLeft';
import IconClose from 'components/icons/iconClose';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
import isNewConsumerApp from 'commons/isNewConsumerApp';
const fullScreenModalRootElement = getOrCreateElementById('FullScreenModal-root');
const FullScreenModal = t0 => {
  const $ = _c(93);
  const {
    children,
    closeAlign: t1,
    closeIcon,
    enableHashHistory: t2,
    className: t3,
    headerCenter,
    headerLeft,
    headerRight,
    hideBack,
    history,
    location: t4,
    isOpen: t5,
    mobileContent,
    mobileContentUnderHeader: t6,
    mobileHeaderCenter,
    mobileHeaderNoPointerEvents: t7,
    mobileHeaderRight,
    mobileHideHeader: t8,
    mobileIsFullHeight: t9,
    mobileNoPadding: t10,
    mobileContentNoPadding: t11,
    mobileNoStickyFooterPadding: t12,
    mobileScrollingHeader,
    mobileStickyFooter,
    mobileVariant,
    modalPath: t13,
    onBack,
    onClose,
    stickyFooter,
    title,
    withUnderLay: t14
  } = t0;
  const closeAlign = t1 === undefined ? "left" : t1;
  const enableHashHistory = t2 === undefined ? true : t2;
  const className = t3 === undefined ? "" : t3;
  let t15;
  if ($[0] !== t4) {
    t15 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t15;
  } else {
    t15 = $[1];
  }
  const location = t15;
  const isOpen = t5 === undefined ? false : t5;
  const mobileContentUnderHeader = t6 === undefined ? null : t6;
  const mobileHeaderNoPointerEvents = t7 === undefined ? false : t7;
  const mobileHideHeader = t8 === undefined ? false : t8;
  const mobileIsFullHeight = t9 === undefined ? true : t9;
  const mobileNoPadding = t10 === undefined ? false : t10;
  const mobileContentNoPadding = t11 === undefined ? false : t11;
  const mobileNoStickyFooterPadding = t12 === undefined ? false : t12;
  const modalPath = t13 === undefined ? "modal" : t13;
  const withUnderLay = t14 === undefined ? false : t14;
  const {
    isMobile
  } = useScreen();
  const modalRef = useFocusOnOpen(isOpen);
  const modalTitleId = useRandomId("FullScreenModal-title");
  useTrapFocus(isOpen && !isMobile, modalRef);
  const [isHistoryPushed, setIsHistoryPushed] = useState(false);
  let t16;
  if ($[2] !== location.state) {
    t16 = JSON.stringify(location.state);
    $[2] = location.state;
    $[3] = t16;
  } else {
    t16 = $[3];
  }
  const locationStateString = t16;
  let t17;
  let t18;
  if ($[4] !== enableHashHistory || $[5] !== history || $[6] !== isHistoryPushed || $[7] !== isMobile || $[8] !== isOpen || $[9] !== location.search || $[10] !== locationStateString || $[11] !== modalPath || $[12] !== onClose) {
    t17 = () => {
      if (!isMobile && enableHashHistory && history && !isHistoryPushed && isOpen) {
        const locationState = JSON.parse(locationStateString || "{}");
        history.push(`${location.search || ""}#${modalPath}`, locationState);
        setIsHistoryPushed(true);
        if (isNewConsumerApp) {
          history.listen(() => {
            onClose();
          });
        } else {
          history.listen(() => {
            if (history.action === "POP") {
              onClose();
            }
          });
        }
      }
    };
    t18 = [isMobile, isOpen, enableHashHistory, history, isHistoryPushed, modalPath, onClose, locationStateString, location.search];
    $[4] = enableHashHistory;
    $[5] = history;
    $[6] = isHistoryPushed;
    $[7] = isMobile;
    $[8] = isOpen;
    $[9] = location.search;
    $[10] = locationStateString;
    $[11] = modalPath;
    $[12] = onClose;
    $[13] = t17;
    $[14] = t18;
  } else {
    t17 = $[13];
    t18 = $[14];
  }
  useEffect(t17, t18);
  let t19;
  let t20;
  if ($[15] !== isOpen) {
    t19 = () => {
      if (!isOpen) {
        setIsHistoryPushed(false);
      }
    };
    t20 = [isOpen];
    $[15] = isOpen;
    $[16] = t19;
    $[17] = t20;
  } else {
    t19 = $[16];
    t20 = $[17];
  }
  useEffect(t19, t20);
  let t21;
  if ($[18] !== enableHashHistory || $[19] !== history || $[20] !== isHistoryPushed || $[21] !== isMobile || $[22] !== onClose) {
    t21 = () => {
      if (!isMobile && enableHashHistory && history && isHistoryPushed) {
        history.goBack();
      }
      onClose();
    };
    $[18] = enableHashHistory;
    $[19] = history;
    $[20] = isHistoryPushed;
    $[21] = isMobile;
    $[22] = onClose;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  const onCloseClick = t21;
  let t22;
  if ($[24] !== onCloseClick || $[25] !== withUnderLay) {
    t22 = event => {
      if (!withUnderLay || typeof event?.target?.className?.includes !== "function") {
        return;
      }
      if (event.target.className.includes("__with-underlay")) {
        onCloseClick();
      }
    };
    $[24] = onCloseClick;
    $[25] = withUnderLay;
    $[26] = t22;
  } else {
    t22 = $[26];
  }
  const checkUnderLayClick = t22;
  useOnEsc(isOpen, onCloseClick);
  if (!isOpen) {
    return null;
  }
  if (isMobile) {
    const t23 = mobileContentUnderHeader || mobileNoPadding;
    const t24 = mobileStickyFooter || stickyFooter;
    const t25 = mobileContent || children;
    let t26;
    if ($[27] !== className || $[28] !== closeIcon || $[29] !== enableHashHistory || $[30] !== isOpen || $[31] !== mobileContentNoPadding || $[32] !== mobileContentUnderHeader || $[33] !== mobileHeaderCenter || $[34] !== mobileHeaderNoPointerEvents || $[35] !== mobileHeaderRight || $[36] !== mobileHideHeader || $[37] !== mobileIsFullHeight || $[38] !== mobileNoStickyFooterPadding || $[39] !== mobileScrollingHeader || $[40] !== mobileVariant || $[41] !== modalPath || $[42] !== onCloseClick || $[43] !== t23 || $[44] !== t24 || $[45] !== t25 || $[46] !== title) {
      t26 = <MobileModal className={className} closeIcon={closeIcon} contentNoPadding={mobileContentNoPadding} contentUnderHeader={mobileContentUnderHeader} enableHashHistory={enableHashHistory} headerCenter={mobileHeaderCenter} headerNoPointerEvents={mobileHeaderNoPointerEvents} headerRight={mobileHeaderRight} hideHeader={mobileHideHeader} isFullHeight={mobileIsFullHeight} isOpen={isOpen} modalPath={modalPath} noPadding={t23} noStickyFooterPadding={mobileNoStickyFooterPadding} onClose={onCloseClick} scrollingHeader={mobileScrollingHeader} stickyFooter={t24} title={title} variant={mobileVariant}>{t25}</MobileModal>;
      $[27] = className;
      $[28] = closeIcon;
      $[29] = enableHashHistory;
      $[30] = isOpen;
      $[31] = mobileContentNoPadding;
      $[32] = mobileContentUnderHeader;
      $[33] = mobileHeaderCenter;
      $[34] = mobileHeaderNoPointerEvents;
      $[35] = mobileHeaderRight;
      $[36] = mobileHideHeader;
      $[37] = mobileIsFullHeight;
      $[38] = mobileNoStickyFooterPadding;
      $[39] = mobileScrollingHeader;
      $[40] = mobileVariant;
      $[41] = modalPath;
      $[42] = onCloseClick;
      $[43] = t23;
      $[44] = t24;
      $[45] = t25;
      $[46] = title;
      $[47] = t26;
    } else {
      t26 = $[47];
    }
    return t26;
  }
  const t23 = `${withUnderLay ? " h-screen left-0 fixed top-0 w-screen bg-[rgba(0,0,0,.6)]" : ""}`;
  const t24 = `bg-white flex flex-col z-[2000] h-screen left-0 fixed top-0 w-screen ${className}`;
  let t25;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <VisuallyHidden>Modal dialog content starts</VisuallyHidden>;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== closeAlign || $[50] !== onCloseClick) {
    t26 = closeAlign === "left" && <button type="button" className="bg-transparent rounded-[3px] border-2 border-solid border-transparent cursor-pointer h-[49px] left-2 px-[7px] py-[13px] absolute top-2 w-[34px] z-[7]" onClick={onCloseClick}><IconSimpleArrowLeft className="h-[49px] w-[30px] px-[7px] py-[13px] absolute z-[6] top-0 left-0 [&_path]:stroke-[#424242]" /></button>;
    $[49] = closeAlign;
    $[50] = onCloseClick;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== hideBack || $[53] !== onBack) {
    t27 = !!onBack && !hideBack && <button type="button" className="bg-transparent rounded-[3px] border-2 border-solid border-transparent cursor-pointer h-[49px] left-2 px-[7px] py-[13px] absolute top-2 w-[34px] z-[7]" onClick={onBack}><IconSimpleArrowLeft className="h-[49px] w-[30px] px-[7px] py-[13px] absolute z-[6] top-0 left-0 [&_path]:stroke-[#424242]" /></button>;
    $[52] = hideBack;
    $[53] = onBack;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== headerLeft) {
    t28 = <div className="z-[1]">{headerLeft}</div>;
    $[55] = headerLeft;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== headerCenter) {
    t29 = <div className="h-full left-0 px-14 py-4 absolute right-0 text-center top-0 z-0 flex flex-col items-center justify-center">{headerCenter}</div>;
    $[57] = headerCenter;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== headerRight) {
    t30 = <div className="z-[1]">{headerRight}</div>;
    $[59] = headerRight;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t28 || $[62] !== t29 || $[63] !== t30) {
    t31 = <div className="items-center flex justify-between pl-[30px] w-full">{t28}{t29}{t30}</div>;
    $[61] = t28;
    $[62] = t29;
    $[63] = t30;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== closeAlign || $[66] !== onCloseClick) {
    t32 = closeAlign === "right" && <button type="button" className="bg-transparent rounded-[3px] border-2 border-solid border-transparent cursor-pointer h-[49px] left-2 px-[7px] py-[13px] absolute top-2 w-[34px] z-[7]" onClick={onCloseClick}><IconClose className="h-[49px] w-[30px] px-[7px] py-[13px] absolute z-[6] top-0 right-0 [&_path]:fill-gray-light6 [&:hover_path]:fill-gray" /></button>;
    $[65] = closeAlign;
    $[66] = onCloseClick;
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  let t33;
  if ($[68] !== t26 || $[69] !== t27 || $[70] !== t31 || $[71] !== t32) {
    t33 = <div className="bg-white relative [border-bottom:1px_solid_#f1f1f1] flex h-[65px] p-4"><div className="items-center flex flex-1 flex-row z-[1]">{t26}{t27}{t31}{t32}</div></div>;
    $[68] = t26;
    $[69] = t27;
    $[70] = t31;
    $[71] = t32;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== modalTitleId || $[74] !== title) {
    t34 = title && <div className="text-xl font-bold text-gray pt-0 px-0 pb-4" id={modalTitleId}>{title}</div>;
    $[73] = modalTitleId;
    $[74] = title;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  let t35;
  if ($[76] !== children || $[77] !== t34) {
    t35 = <div className="bg-white relative flex-1 overflow-auto" id="FullScreen-content">{t34}{children}</div>;
    $[76] = children;
    $[77] = t34;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] !== stickyFooter) {
    t36 = <div className="FullScreenModal__sticky-footer">{stickyFooter}</div>;
    $[79] = stickyFooter;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  let t37;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <VisuallyHidden>Modal dialog content ends</VisuallyHidden>;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  let t38;
  if ($[82] !== t24 || $[83] !== t33 || $[84] !== t35 || $[85] !== t36) {
    t38 = <BodyScrollLock className={t24}>{t25}{t33}{t35}{t36}{t37}</BodyScrollLock>;
    $[82] = t24;
    $[83] = t33;
    $[84] = t35;
    $[85] = t36;
    $[86] = t38;
  } else {
    t38 = $[86];
  }
  let t39;
  if ($[87] !== checkUnderLayClick || $[88] !== modalRef || $[89] !== modalTitleId || $[90] !== t23 || $[91] !== t38) {
    t39 = createPortal(<div ref={modalRef} role="dialog" aria-labelledby={modalTitleId} className={t23} onClick={checkUnderLayClick}>{t38}</div>, fullScreenModalRootElement);
    $[87] = checkUnderLayClick;
    $[88] = modalRef;
    $[89] = modalTitleId;
    $[90] = t23;
    $[91] = t38;
    $[92] = t39;
  } else {
    t39 = $[92];
  }
  return t39;
};
FullScreenModal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeAlign: PropTypes.oneOf(['left', 'right']),
  closeIcon: PropTypes.node,
  enableHashHistory: PropTypes.bool,
  headerCenter: PropTypes.node,
  headerLeft: PropTypes.node,
  headerRight: PropTypes.node,
  hideBack: PropTypes.bool,
  history: PropTypes.shape({
    action: PropTypes.string,
    goBack: PropTypes.func,
    listen: PropTypes.func,
    push: PropTypes.func
  }),
  isOpen: PropTypes.bool,
  location: PropTypes.object,
  mobileContent: PropTypes.node,
  mobileContentUnderHeader: PropTypes.bool,
  mobileHeaderCenter: PropTypes.node,
  mobileHeaderNoPointerEvents: PropTypes.bool,
  mobileHeaderRight: PropTypes.node,
  mobileHideHeader: PropTypes.bool,
  mobileIsFullHeight: PropTypes.bool,
  mobileNoPadding: PropTypes.bool,
  mobileContentNoPadding: PropTypes.bool,
  mobileNoStickyFooterPadding: PropTypes.bool,
  mobileScrollingHeader: PropTypes.node,
  mobileStickyFooter: PropTypes.node,
  mobileVariant: PropTypes.string,
  modalPath: PropTypes.string,
  onBack: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  stickyFooter: PropTypes.node,
  title: PropTypes.string,
  withUnderLay: PropTypes.bool
};
export default withBrowserOnly(withRouter(FullScreenModal));